import {IDataTag, IDataTagAssignment, IDataTagSpecific} from "~/interfaces/dataTagInterfaces";
import {
  STATE as DataTagAssignmentState,
  STORE_NAME as DataTagAssignmentStoreName
} from "../../common/dataTagAssignmentStoreFactory";
import {DataTagType} from "~/enums/dataTagType";
import SensitiveDataIcon from "../components/sensitive-data-icon.vue";
import {ModelType} from "~/enums/modelType";
import {IObjectModelProperty} from "~/interfaces/objectModelInterfaces";

export default {
  components: {
    SensitiveDataIcon,
  },
  computed: {
    dataTaggableField(): IObjectModelProperty {
      if (import.meta.env.MODE === 'development') {
        throw new Error("Mixed in component must have dataTaggableField computed property which returns an ObjectModelProperty");
      }
      return null;
    },
    dataTags(): IDataTag[] {
      return this.$store.state[DataTagAssignmentStoreName][DataTagAssignmentState.dataTags];
    },
    dataTagAssignments(): IDataTagAssignment[] {
      return this.$store.state[DataTagAssignmentStoreName][DataTagAssignmentState.dataTagAssignments];
    },
    securityDataTags(): IDataTagSpecific<DataTagType.Security>[] {
      return this.dataTags.filter(dataTag => dataTag.tag_type === DataTagType.Security);
    },
    securityDataTagAssignments(): IDataTagAssignment[] {
      return this.dataTagAssignments.filter(assignment => {
        return !!this.securityDataTags.find(securityTag => securityTag.id === assignment.tag_id);
      });
    },
    propertyIsSecurityTagged(): boolean {
      return !!this.securityDataTagAssignments.find(assignment => {
        return assignment.taggable_field_type === ModelType.ObjectModelProperty &&
          assignment.taggable_field_identifiers.includes(this.dataTaggableField.id);
      });
    },
  },
}